<app-header (filterChange)="onCategoryFilterChange($event)" (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)" (searchFilterChange)="onSearchFilterChange($event)">
</app-header>

<section class="category-section">
  <div class="row-container">
    <div class="row">
      <div class="col-25 mr-10 shop-by-category">

        <mat-tab-group class="outline-tab red-tab" mat-stretch-tabs animationDuration="0ms" mat-align-tabs="start">
          <mat-tab>
            <ng-template mat-tab-label>

              Category List
            </ng-template>
            <!-- <h1 class="heading-2">Shop By Category</h1> -->
            <ng-container *ngIf="categoryList && categoryList.length > 0">
              <ul class="category-list scrollbar-1">
                <li *ngFor="let category of categoryList | filter: searchInput,let i=index"
                  [class.active]="category.categoryCode === selectedCategory"
                  (click)="sidebarSelectedCategory(category)">
                  <img [src]="getCategoryImage(category)" alt="" />
                  {{ category.categoryName }}
                </li>
              </ul>
            </ng-container>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              Brand List
            </ng-template>

            <div class="dw_search cat-search" style="margin: 10px 20px;">
              <input type="text" class="form-control" placeholder="Search brands..." [(ngModel)]="searchTerm"
                (input)="onSearchBrand($event)" autocomplete="off">
              <i class="material-icons search-icon" *ngIf="!searchTerm">search</i>
              <i class="material-icons search-icon" *ngIf="searchTerm" (click)="clearSearch()"
                style="cursor: pointer;">close</i>
            </div>

            <div class="search-results-info" *ngIf="searchTerm"
              style="padding: 5px 20px; font-size: 10px; color: #A3A3A3;">
              Found {{ filteredBrandList.length }} of {{ brandList.length }} brands
            </div>

            <ul class="category-list brand-list scrollbar-1">
              <li *ngFor="let brandData of filteredBrandList; let i=index">
                <img src="{{imgPrefix}}{{brandData?.brandImages?.logo?.links?.logo}}" alt="{{brandData?.brandName}}"
                  onerror="this.src='../../../assets/img/NoImg.png'" />
                <span (click)="navigateToBrandPage(brandData?.idBrand, brandData?.brandName)">
                  {{ brandData?.brandName }}
                </span>
              </li>
            </ul>

            <!-- No results message -->
            <div class="no-results-message" *ngIf="searchTerm && filteredBrandList.length === 0"
              style="text-align: center; padding: 40px 20px; color: #A3A3A3;">
              <div style="font-size: 48px; margin-bottom: 10px;">🔍</div>
              <p style="font-size: 12px; margin-bottom: 10px;">No brands found for "{{ searchTerm }}"</p>
              <button type="button" class="btn btn-sm" (click)="clearSearch()"
                style="background: #D9232D; color: white; border: none; padding: 5px 15px; border-radius: 4px; font-size: 11px; cursor: pointer;">
                Clear Search
              </button>
            </div>
          </mat-tab>


        </mat-tab-group>





      </div>
      <div class="col-75 category-view" *ngIf="selectedCategoryResponse">
        <h2 class="heading-3">{{ selectedCategoryResponse?.defaultChildCategoryDetails?.categoryName }}</h2>
        <div class="product-category" *ngFor="let category of selectedcategoryList">
          <label class="line-after"><span>{{ category.categoryName }}</span></label>
          <ng-container *ngIf="category?.childCategories">
            <ul *ngIf="category.childCategories">
              <li *ngFor="let subCategory of category.childCategories">
                 <ng-container *ngIf="subCategory.categoryEnableFlagEnterprise">
                <div class="product-card" (click)="oncontentSearchFilterChange(subCategory)">
                  <img style="cursor:pointer;" [src]="getContentImage(subCategory)" alt="">
                  {{ subCategory.categoryName }}
                </div>
                </ng-container>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="category?.childCategories==null">
            <ul>
              <li>
                <div class="product-card" (click)="oncontentSearchFilterChange(category)">
                  <img style="cursor:pointer;" [src]="getContentImage(category)" alt="">
                  <!-- {{ category.categoryName }} -->
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>


    </div>
  </div>
</section>